import { useState, useEffect } from "react";
import { Phone, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

const CALL_AFTER_S = 2 * 60;  // 2 minutes
const WARN_AFTER_S = 5 * 60;  // 5 minutes

export default function ArrivedCountdown({ arrivedAt, phone }) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!arrivedAt) return;
    const tick = () => setElapsed(Math.floor((Date.now() - new Date(arrivedAt).getTime()) / 1000));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [arrivedAt]);

  if (!arrivedAt) return null;

  const remaining = Math.max(0, WARN_AFTER_S - elapsed);
  const mins = Math.floor(remaining / 60);
  const secs = remaining % 60;
  const showCall = elapsed >= CALL_AFTER_S;
  const showWarn = elapsed >= WARN_AFTER_S;

  return (
    <div
      className="rounded-lg border-2 border-red-500 bg-red-50 p-3 space-y-2"
      data-testid="arrived-countdown"
    >
      <div className="flex items-center justify-between">
        <span className="font-bold text-red-700 text-sm">
          📍 Cliente notificado
        </span>
        {!showWarn && (
          <span
            className="font-mono text-red-700 font-bold text-lg"
            data-testid="countdown-timer"
          >
            {String(mins).padStart(2, "0")}:{String(secs).padStart(2, "0")}
          </span>
        )}
      </div>

      {showCall && phone && (
        <a href={`tel:${phone}`} className="block w-full" data-testid="call-client-link">
          <Button
            className="w-full bg-red-600 hover:bg-red-700 text-white font-bold text-sm gap-2"
            data-testid="call-client-btn"
          >
            <Phone className="w-4 h-4" /> Llamar al cliente
          </Button>
        </a>
      )}

      {showWarn && (
        <div
          className="flex items-start gap-2 text-xs text-red-800 bg-red-100 rounded p-2"
          data-testid="restaurant-warning"
        >
          <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0 text-red-600" />
          <span>
            Si no consigues contactar, llama al restaurante antes de marcar como entregado.
          </span>
        </div>
      )}
    </div>
  );
}
